import type { UnderwayActivityDetails } from '@/components/automation/UnderwayPopup/types';

// Structural so this helper never imports page types (boundaries rule) — a real
// `WorkflowRule` satisfies it.
type RuleLike = {
  actions?: ReadonlyArray<{
    position?: number;
    action_config?:
      | { automation_mode?: string }
      | Record<string, unknown>
      | null;
  }> | null;
};

// Underway-row activity details for a MOVE-triggered automation, derived from
// the rule itself. The move path has no BE `next_action` to read (unlike the
// bulk/sync add path's `detailsFromNextAction`), so it can only surface fields
// the rule carries: the interview scheduling mode
// (`action_config.automation_mode` on the first/next action → "using <mode>").
// Survey audience / reviewer recipients are BE-resolved participants, absent
// from the rule, so they stay undefined here.
export const detailsFromRule = (
  rule: RuleLike | null | undefined
): UnderwayActivityDetails => {
  const actions = rule?.actions ?? [];
  // The action that fires first (smallest position) is the one starting soon —
  // mirror `getActivityLabel`'s selection.
  const first =
    [...actions].sort((a, b) => (a.position ?? 0) - (b.position ?? 0))[0] ??
    actions[0];
  const config = (first?.action_config ?? {}) as { automation_mode?: string };
  return {
    scheduleMode: config.automation_mode,
  };
};
